var _circle, _g, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolanaEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3499_8781",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3499_8781)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1734 18.839C34.0038 18.9919 33.7846 19.0784 33.5563 19.0825H11.8716C11.1016 19.0825 10.7133 18.203 11.2464 17.6888L14.808 14.2544C14.9735 14.0945 15.1936 14.0036 15.4237 14H37.1937C37.9704 14 38.3506 14.8877 37.8107 15.4046L34.1734 18.839Z",
    fill: "url(#paint0_linear_3499_8781)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1734 35.7648C34.0028 35.9152 33.7838 35.9993 33.5563 36.0016H11.8716C11.1016 36.0016 10.7133 35.1288 11.2464 34.6132L14.808 31.1707C14.9742 31.0131 15.1947 30.9255 15.4237 30.9258H37.1937C37.9704 30.9258 38.3506 31.8054 37.8107 32.3196L34.1734 35.7648Z",
    fill: "url(#paint1_linear_3499_8781)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1734 22.7056C34.0028 22.5551 33.7838 22.471 33.5563 22.4688H11.8716C11.1016 22.4688 10.7133 23.3416 11.2464 23.8558L14.808 27.2996C14.9772 27.4522 15.1958 27.5387 15.4237 27.5432H37.1937C37.9704 27.5432 38.3506 26.6636 37.8107 26.1494L34.1734 22.7056Z",
    fill: "url(#paint2_linear_3499_8781)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3499_8781",
    x1: 11.0015,
    y1: 89.7131,
    x2: 38.7539,
    y2: 89.4587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#599DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47F8C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3499_8781",
    x1: 11.0015,
    y1: 20.7431,
    x2: 38.5766,
    y2: 20.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C44FE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73B0D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3499_8781",
    x1: 12.559,
    y1: 25.006,
    x2: 37.015,
    y2: 25.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#778CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DCDC9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanaEmail);
export default __webpack_public_path__ + "static/media/solanaEmail.3235d8115946e5e7473e2b4767a32a6f.svg";
export { ForwardRef as ReactComponent };